// Vendor Libs
import {applyMiddleware, createStore, compose} from 'redux';
import {routerMiddleware} from 'react-router-redux';
import {createBrowserHistory} from 'history';
import {createLogger} from 'redux-logger';
import promise from 'redux-promise-middleware';
import thunk from 'redux-thunk';

// Lib Core
import freezer from './lib-core/redux-freezer';
import {reduxDev, styleLoader} from './lib-core/redux-dev';

// Reducers
import rootReducer from './reducers';

// Lib App
import fetchMiddleware from './lib-app/fetch-middleware';
import formMiddleware from './lib-app/form-middleware';
import router from './lib-app/router-middleware';
import preferencesMiddleware from './lib-app/preferences-middleware';

export const history = createBrowserHistory();
const store = compose(
    applyMiddleware(
        promise(),
        thunk,
        freezer,
        routerMiddleware(history),
        fetchMiddleware,
        formMiddleware,
        preferencesMiddleware,
        router,
        createLogger({collapsed: true})
    ),
    reduxDev()
)(createStore)(rootReducer);

if (module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(require('./reducers').default));
    styleLoader();
}

export default {...store, history};
